import React from 'react'
import { Link, CtaArrow } from 'newComponents'
import { track } from '../../../utils/thirdPartyUtils'
import './styles.scss'

const handleEventTrigger = (eventName) => {
  track(eventName)
}

const NewButton = ({ to, children, className, onClick = () => {}, eventName, chevron }) => (
  <Link
    to={to}
    className={`new-button ${className || ''}`}
    onClick={eventName ? () => handleEventTrigger(eventName) : onClick}
  >
    {children} {chevron && <CtaArrow />}
  </Link>
)
export default NewButton
